import React, {useCallback, useContext, useMemo, useState} from 'react';
import {useShoppingRoadManager} from "./useShoppingRoad";
import {useItemKrTextData} from "../../probability/useItemData";
import {AuthContext} from "../../../shared/contexts/authContext";
import IsLoading from "../../../shared/components/IsLoading";
import ErrorPage from "../../../shared/components/ErrorPage";
import TablePage from "../../../pages/tablePage/TablePage";
import ShoppingRoadManagerEditModal from "./ShoppingRoadManagerEditModal";
import {parseRewards} from "../../../shared/utils/shoppingRoadUtils";

const ShoppingRoadManager = () => {
    const {currentUser} = useContext(AuthContext);
    const {data, isLoading, error} = useShoppingRoadManager();
    const {data: itemRaw} = useItemKrTextData();
    const itemData = itemRaw?.[currentUser?.target] || [];
    const [rowData, setRowData] = useState(null);

    const renderRewards = useCallback((r) => {
        const rewards = parseRewards(r);
        if (!rewards.length) return '-';
        return rewards.map((rw, i) => {
            const item = itemData.find(d => d.index === rw.id && d.itemType === rw.type);
            const label = item ? `${item.name}(${rw.id})` : `${rw.id}`;
            return (
                <span key={i} style={{marginRight: 4}}>
                    {label} x {rw.quantity}{i < rewards.length - 1 ? ',' : ''}
                </span>
            );
        });
    }, [itemData]);

    const columns = useMemo(() => ([
        {
            title: 'seq',
            dataIndex: 'seq',
            key: 'seq',
            width: 60,
            search: true,
        },
        {
            title: 'Memo',
            dataIndex: 'memo',
            key: 'memo',
        },
        {
            title: '재시작 비용',
            dataIndex: 'restartDia',
            key: 'restartDia',
            width: 100,
        },
        {
            title: '재선택 비용',
            dataIndex: 'refreshDia',
            key: 'refreshDia',
            width: 100,
        },
        {
            title: '무료 재선택 횟수',
            dataIndex: 'refreshFree',
            key: 'refreshFree',
            width: 120,
        },
        {
            title: '쉬움 단계',
            dataIndex: 'easyRewards',
            key: 'easyRewards',
            render: renderRewards,
        },
        {
            title: '보통 단계',
            dataIndex: 'normalRewards',
            key: 'normalRewards',
            render: renderRewards,
        },
        {
            title: '어려움 단계',
            dataIndex: 'hardRewards',
            key: 'hardRewards',
            render: renderRewards,
        },
    ]), [renderRewards]);

    if (isLoading) return <IsLoading/>;
    if (error) return <ErrorPage error={error}/>;

    const props = {
        columns: columns,
        localData: data?.rows || [],
        loading: isLoading,
        modal: ShoppingRoadManagerEditModal,
        buttonText: '신규 쇼핑 로드 매니저 추가',
        rowData: rowData,
        setRowData: setRowData,
        modalResizable: true,
        modalOptions: {
            tbl: data?.tbl || {},
        },
    };

    return (
        <div>
            <TablePage {...props}/>
        </div>
    );
};

export default ShoppingRoadManager;